import React from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import type { DisplayPost } from "./blogTypes";

const BlogsCard: React.FC<{ post: DisplayPost }> = ({ post }) => {
  const history = useHistory();

  return (
    <div
      className="bp-card"
      onClick={() => history.push(`/blogs/${post.slug}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") history.push(`/blogs/${post.slug}`);
      }}
    >
      <div className="bp-card__media">
        <img src={post.cover} alt={post.title} />
        <div className="bp-card__media-scrim" />
        {post.category && <span className="bp-card__category">{post.category}</span>}
        <span className="bp-card__stamp">© eZy</span>
      </div>
      <div className="bp-card__body">
        <div className="bp-card__date">
          {post.date ? moment(post.date).format("MMMM D, YYYY") : ""}
          {post.readMin ? ` · ${post.readMin} min read` : ""}
        </div>
        <h3 className="bp-card__title">{post.title}</h3>
        <p className="bp-card__excerpt">{post.excerpt}</p>
        <span className="bp-card__read">
          Read <span aria-hidden="true">→</span>
        </span>
      </div>
    </div>
  );
};

export default BlogsCard;
